import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as enums from '../../../../../enums'
import * as tc from '../tc'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: tc.RESOURCE.payload.dimension.partialId,
      partialId: tc.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Subawards at this risk level or above should include this term/condition',
    isOptional: true,
    name: 'Risk Threshold',
    partialId: PartialId.Standard.create('risk_threshold'),
    type: {
      enumId: core.dms.models.Enum.Id.from(enums.subawardRisk.RESOURCE.payload),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
